import { MdAddCircleOutline } from 'react-icons/md';
import { Button } from '@ds';
import { CaseStatus } from '@/api/apis/case';
import { caseStatusNames } from '@/constants/case/case.constants';

type AvailableStatusProps = {
  disabled: boolean;
  status: CaseStatus;
  onClick: (status: CaseStatus) => void;
};

export const AvailableStatus = ({ disabled, status, onClick }: AvailableStatusProps) => {
  return (
    <Button
      variant="light"
      disabled={disabled}
      className="flex justify-between hover:bg-base-40! bg-base-70 py-5 px-3 rounded-lg"
      onClick={() => onClick(status)}
      endContent={<MdAddCircleOutline size={16} color={disabled ? '' : '#3F83F8'} />}
    >
      <span className="text-m-m font-medium">{caseStatusNames[status]}</span>
    </Button>
  );
};
